import { useFormEffects } from '@formily/react';
import { genValidateField } from '../Form/extendsEffects/validateField';
import { useFieldContext } from '../Other'; // todo 和 extedns Effects里的validate逻辑，进行合并

export const useArrayUnion = (arrayUnion, ruleText = '不能重复') => {
  const {
    preName
  } = useFieldContext();
  useFormEffects(($, f) => {
    if (!arrayUnion) {
      return;
    }

    const path = preName.toString();
    const validateField = genValidateField($, f);
    arrayUnion.forEach(key => {
      const validatePath = `${path}.*.${key}`;
      validateField(validatePath, [path], ({
        value
      }) => {
        const array = f.getFieldValue(path);

        if (value == null) {
          return null;
        }

        const sameValue = array.filter(v => {
          return v[key] === value;
        });

        if (sameValue.length > 1) {
          return ruleText;
        }

        return null;
      });
    });
  });
};
//# sourceMappingURL=es/validator/useArrayUnion.js.map